import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 289.2 134.6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M37.8 82.3S2.6 131.1 0 134.6c5.4-.9 20.5-4.1 32.6-19.7l23.8-30.2c.4-.4 7.1-8.9 17.3-10.6l103-19c24.8-4.8 51.2-15.1 78.4-31.3 16.6-9.9 28.7-19.2 34.1-23.8-9.3 2.4-203.3 49.9-203.3 49.9-32.8 8-48 32.2-48.2 32.4Z",
      style: {"fill":"#004595","fill-rule":"evenodd"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.4 133.5c8.9-.2 31.8-1.1 31.8-1.1 26.6-.9 47.3-17.3 53.6-22.9-7.1.6-53.1 4.8-53.1 4.8s-10.8.9-11.4 1.1c-8.9 10.8-16 15.8-20.7 18.1Z",
      style: {"fill":"#e53138","fill-rule":"evenodd"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M62.4 90.1S52 102.8 49.7 105.9c4.3-.4 54.9-5.8 54.9-5.8 17.1-1.9 34.8-8.2 52.9-19 10.6-6.3 18.1-12.3 21.8-15.3-11.9 1.9-102.6 16.8-102.6 16.8-9.1 1.5-14 7.3-14.3 7.6Z",
      style: {"fill-rule":"evenodd","fill":"#ffed00"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "9U-logo"}) } }